<template>
  <Headers :type="prop.type" :countDown="prop.countDown"> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <PogressBarStep :cardName="prop.cardName" :currentStep="15">
    </PogressBarStep>
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <h2>{{ t("ccOnBoarding.personalInformation.personalInformation") }}</h2>
        <div :class="[deviceType, 'content']">
          <div :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.motherMaidenName"
                  field="motherMaidenName"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.motherMaidenName')
                  "
                  :max-length="100"
                  :autocomplete="'new-password'"
                  @keydown="handleNameKeyDown"
                />
              </div>
              <div :class="[deviceType, 'flex_half']">
                <DropDown
                  v-model="prop.personalInformation.academic"
                  :selectedOption="prop.personalInformation.academic"
                  :options="academicList"
                  :value="academicList"
                  field="academic"
                  :placeholder="t('ccOnBoarding.personalInformation.academic')"
                />
              </div>
            </div>
            <div
              v-if="prop.personalInformation.academic == '9'"
              :class="[deviceType, 'container']"
            >
              <div :class="[deviceType, 'flex_half']"></div>
              <div :class="[deviceType, 'flex_half']">
                <InputText
                  class="inputcomponent"
                  v-model="prop.personalInformation.otherAcademic"
                  field="otherAcademic"
                  :required="false"
                  :placeholder="
                    t('ccOnBoarding.personalInformation.otherAcademic')
                  "
                  :max-length="20"
                  :autocomplete="'new-password'"
                />
              </div>
            </div>
          </div>
        </div>
        <template v-if="employmentDetails.occupation == '1'">
          <h2>{{ t("ccOnBoarding.employmentDetails.employmentDetails") }}</h2>
          <div :class="[deviceType, 'content']">
            <div :class="[deviceType, 'separator']">
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'inputText']">
                  <InputText
                    class="inputcomponent"
                    v-model="prop.employmentDetails.sstRegistrationNo"
                    field="sstRegistrationNo"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.employmentDetails.sstRegistrationNo')
                    "
                    :max-length="15"
                    :autocomplete="'new-password'"
                    @keydown="handleKeyDown"
                    @keydown.enter.prevent="handleEnterKey"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
        <h2>{{ t("ccOnBoarding.principalCard.principalCardDetails") }}</h2>
        <div :class="[deviceType, 'content']">
          <div :class="[deviceType, 'separator']">
            <div :class="[deviceType, 'container']">
              <div :class="[deviceType, 'inputText']">
                <InputText
                  class="inputcomponent"
                  v-model="principalDetails.name"
                  :value="principalDetails.name"
                  field="name"
                  :required="false"
                  :placeholder="t('ccOnBoarding.principalCard.nameOnCard')"
                  :max-length="19"
                  :autocomplete="'new-password'"
                  @keydown="handleNameKeyDown"
                />
              </div>
            </div>
            <div :class="[deviceType, 'container']">
              <div
                v-if="
                  principalDetails.deliveryOption &&
                  principalDetails.deliveryOption == 'B'
                "
                :class="[deviceType, 'flex_half']"
              >
                <DropDown
                  v-model="principalDetails.deliveryOption"
                  :selectedOption="principalDetails.deliveryOption"
                  :options="deliveryList"
                  :value="deliveryList"
                  field="deliveryOption"
                  :placeholder="
                    t('ccOnBoarding.principalCard.cardDeliveryOption')
                  "
                  :disabled="
                    (prop.ekyc == 'FAILED' ||
                      prop.ekyc == 'SKIP' ||
                      prop.ekyc == '') &&
                    prop.verification == 'false'
                  "
                />
              </div>
              <div
                v-else-if="
                  !principalDetails.deliveryOption ||
                  principalDetails.deliveryOption == 'H'
                "
                class="flex"
              >
                <DropDown
                  v-model="principalDetails.deliveryOption"
                  :selectedOption="principalDetails.deliveryOption"
                  :options="deliveryList"
                  :value="deliveryList"
                  field="deliveryOption"
                  :placeholder="
                    t('ccOnBoarding.principalCard.cardDeliveryOption')
                  "
                />
              </div>
              <div
                v-if="principalDetails.deliveryOption == 'B'"
                :class="[deviceType, 'flex_half']"
              >
                <DropDown
                  v-if="principalDetails.deliveryOption == 'B'"
                  v-model="principalDetails.branch"
                  :selectedOption="principalDetails.branch"
                  :options="branchList"
                  :value="branchList"
                  field="branch"
                  :placeholder="t('ccOnBoarding.principalCard.branch')"
                />
              </div>
            </div>
            <div v-if="principalDetails.deliveryOption == 'H'">
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    v-model="principalDetails.address1"
                    field="deliveryAddress1"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.principalCard.deliveryAddress1')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                    :disabled="true"
                  />
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    v-model="principalDetails.address2"
                    field="deliveryAddress2"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.principalCard.deliveryAddress2')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                    :disabled="true"
                  />
                </div>
              </div>
              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    v-model="principalDetails.address3"
                    field="deliveryAddress3"
                    :required="false"
                    :placeholder="
                      t('ccOnBoarding.principalCard.deliveryAddress3')
                    "
                    :max-length="50"
                    :autocomplete="'new-password'"
                    :disabled="true"
                  />
                </div>
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    v-bind="$attrs"
                    class="inputcomponent"
                    v-model="principalDetails.postCode"
                    field="postCode"
                    :postCode="true"
                    :required="false"
                    :placeholder="t('ccOnBoarding.principalCard.postCode')"
                    :max-length="5"
                    :autocomplete="'new-password'"
                    onkeypress="
                      return event.charCode >= 48 && event.charCode <= 57;
                    "
                    :number="'true'"
                    :type="'text'"
                    :inputmode="'numeric'"
                    :pattern="'[0-9]*'"
                    @keydown.enter.prevent="handleEnterKey"
                    :disabled="true"
                  />
                </div>
              </div>

              <div :class="[deviceType, 'container']">
                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    :disabled="true"
                    class="inputcomponent"
                    v-model="prop.principalDetails.city"
                    :value="prop.principalDetails.city"
                    field="city"
                    :required="false"
                    :placeholder="t('ccOnBoarding.principalCard.city')"
                    :autocomplete="'new-password'"
                  />
                </div>

                <div :class="[deviceType, 'flex_half']">
                  <InputText
                    class="inputcomponent"
                    :disabled="true"
                    v-model="principalDetails.state"
                    :value="principalDetails.state"
                    field="state"
                    :required="false"
                    :placeholder="t('ccOnBoarding.principalCard.state')"
                    :max-length="21"
                    :autocomplete="'new-password'"
                  />
                </div>
              </div>
            </div>
            <div class="container agreement">
              <p class="description">
                {{ t("ccOnBoarding.principalCard.statement") }}
              </p>
              <div class="agree">
                <section class="radioClass">
                  <RadioButton
                    v-for="option in hrcQuestionnaireEnum"
                    :key="option.value"
                    :label="option.label"
                    :values="option.value"
                    class="radioHorizontal"
                    field="statement"
                    id="q2"
                    :selected-value="prop.principalDetails.eStatement"
                    :label-class="'radioLabel'"
                    @selected="question2Selection"
                    :class="{ 'display-flex': true }"
                  />
                </section>
              </div>
              <pre class="help" v-if="!errorMessage">
                  {{ errorMessage }}</pre
              >
              <pre class="help" v-else-if="error && errorMessage">{{
                errorMessage
              }}</pre>
              <pre class="help" v-else>&nbsp</pre>

              <p
                v-if="
                  principalDetails.eStatement == 'No' &&
                  prop.principalDetails.eStatement == 'No'
                "
                class="remark"
              >
                {{ t("ccOnBoarding.principalCard.statementRemark") }}
              </p>

              <div
                v-if="
                  principalDetails.eStatement == 'No' &&
                  prop.principalDetails.eStatement == 'No'
                "
                :class="[deviceType, 'container']"
              >
                <div class="flex">
                  <DropDown
                    v-model="principalDetails.billingAddress"
                    :selectedOption="principalDetails.billingAddress"
                    :options="billingAddressList"
                    :value="billingAddressList"
                    field="billingAddress"
                    :placeholder="
                      t('ccOnBoarding.principalCard.billingAddress')
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="description">
          {{ t("ccOnBoarding.basicInformation.question") }}
        </p>
        <p class="remark">
          ({{ t("ccOnBoarding.basicInformation.questionRemark") }})
        </p>
        <div class="agree">
          <section class="radioClass">
            <RadioButton
              v-for="option in hrcQuestionnaireEnum"
              :key="option.value"
              :label="option.label"
              :values="option.value"
              class="radioHorizontal"
              field="question"
              id="q2"
              :selected-value="prop.basicInformation.question1"
              :label-class="'radioLabel'"
              @selected="question1Selection"
              :class="{ 'display-flex': true }"
            />
          </section>
        </div>
        <pre class="help" v-if="!errorMessage">
                  {{ errorMessage }}</pre
        >
        <pre class="help" v-else-if="error && errorMessage">{{
          errorMessage
        }}</pre>
        <pre class="help" v-else>&nbsp</pre>

        <div v-if="prop.basicInformation.question1 == 'Yes'">
          <p class="smallTitle">
            {{ t("ccOnBoarding.basicInformation.repaymentTitle") }}
          </p>

          <div :class="[deviceType, 'inputText']">
            <NewCurrencyInput
              class="inputcomponent"
              v-model.number="prop.basicInformation.repayment"
              field="repayment"
              :required="false"
              :max-length="15"
              :placeholder="t('ccOnBoarding.basicInformation.repayment')"
              :autocomplete="'new-password'"
              :inputmode="'numeric'"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57;"
              @keydown.enter.prevent="handleEnterKey"
            />
          </div>
        </div>
        <div v-if="deviceType != 'Mobile'" :class="[deviceType, 'agree2']">
          <CheckBoxValid
            id="agree"
            class="checkbox"
            :required="false"
            field="ampConsent"
            @selected="handleCCConsent"
            :selected-value="prop.basicInformation.consent"
            :nopre="true"
          >
            <template v-slot:label>
              <p class="checkbox-label2">
                {{ t("ccOnBoarding.basicInformation.agree") }}
                <a class="termOfService" @click="openDeclarationAgreementModal">
                  {{ t("ccOnBoarding.basicInformation.policy") }}</a
                >, {{ t("ccOnBoarding.basicInformation.credit") }}
                <a :href="cc_tnc_path" target="_blank" class="termOfService">
                  {{ t("ccOnBoarding.basicInformation.terms") }}</a
                >
                {{ t("ccOnBoarding.basicInformation.and") }}
                <a :href="cc_psd_path" target="_blank" class="termOfService">
                  {{ t("ccOnBoarding.basicInformation.disclosure") }}</a
                >.
              </p>
            </template>
          </CheckBoxValid>
        </div>
        <div v-if="deviceType != 'Mobile'" :class="[deviceType, 'virtualCC']">
          <VirutalCCBar></VirutalCCBar>
        </div>

        <div v-if="deviceType == 'Mobile'" :class="[deviceType, 'inner-last']">
          <div :class="[deviceType, 'agree2']">
            <CheckBoxValid
              id="agree"
              class="checkbox"
              :required="false"
              field="ampConsent2"
              @selected="handleCCConsent"
              :selected-value="prop.basicInformation.consent"
              :disabled="prop.status === 'false'"
              :nopre="true"
            >
              <template v-slot:label>
                <p class="checkbox-label2">
                  {{ t("ccOnBoarding.basicInformation.agree") }}
                  <a
                    class="termOfService"
                    @click="openDeclarationAgreementModal"
                  >
                    {{ t("ccOnBoarding.basicInformation.policy") }}</a
                  >, {{ t("ccOnBoarding.basicInformation.credit") }}
                  <a :href="cc_tnc_path" target="_blank" class="termOfService">
                    {{ t("ccOnBoarding.basicInformation.terms") }}</a
                  >
                  {{ t("ccOnBoarding.basicInformation.and") }}
                  <a :href="cc_psd_path" target="_blank" class="termOfService">
                    {{ t("ccOnBoarding.basicInformation.disclosure") }}</a
                  >.
                </p>
              </template>
            </CheckBoxValid>
          </div>
          <div v-if="deviceType == 'Mobile'" :class="[deviceType, 'virtualCC']">
            <VirutalCCBar></VirutalCCBar>
          </div>
        </div>
        <div :class="[deviceType, 'buttoncontainer']">
          <button
            v-if="prop.summarySetting.additionalInformationJump == false"
            :class="[deviceType, 'left-button']"
            type="button"
            @click="handleBack"
          >
            {{ t("ccOnBoarding.back") }}
          </button>
          <div v-else :class="[deviceType, 'left-button:disabled']"></div>
          <button
            v-if="prop.summarySetting.additionalInformationJump == false"
            :class="[deviceType, 'right-button']"
            :disabled="isBtnDisabled"
          >
            {{ t("ccOnBoarding.next") }}
          </button>
          <button
            v-else
            :class="[deviceType, 'summary-button']"
            :disabled="isBtnDisabled"
          >
            {{ t("ccOnBoarding.backToSummary") }}
          </button>
        </div>
      </div>
    </Form>
  </div>
  <div v-if="prop.overlay" class="overlay">
    <div class="text-center flex-container">
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
        <!-- <b>Submit Fail</b> -->
      </p>
      <br />
      <div class="spinner-border" role="status">
        <span class="sr-only">{{
          t("ccOnBoarding.uploadDocument.loading2")
        }}</span>
      </div>
      <br />
      <br />
      <p class="loading">
        <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
      </p>
      <br />
      <br />
    </div>
  </div>
  <PopupMessage
    name="pdfName"
    :type="pdfType"
    :header="headerName"
    v-if="isTNCModalOpen"
    @close-modal="closeTNCModal"
    :popup="true"
  >
  </PopupMessage>
</template>

<script setup lang="ts">
import {
  ref,
  onMounted,
  computed,
  watch,
  watchEffect,
  onBeforeMount,
  type PropType,
  type Ref,
} from "vue";
import Headers from "./components/Headers.vue";
import PogressBarStep from "./components/ProgressBarStep.vue";
import DropDown from "./components/NewDropDownComponent.vue";
import InputText from "./components/NewInputTextComponent.vue";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import RadioButton from "./components/NewRadioButtonComponent.vue";
import type { PersonalInformation } from "@/interface/FormCC";
import type { SummarySetting } from "@/interface/FormCC";
import { deviceDetect } from "mobile-device-detect";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type { PrincipalCardDetails } from "@/interface/FormCC";
import hrcQuestionnaireEnum from "@/enum/HRCQuestionnaireEnum";
import type { BasicInformation, Card } from "@/interface/FormCC";
import type { EmploymentDetails } from "@/interface/FormCC";
import Constants from "@/constants/constants";
import PopupMessage from "./components/PopupMessage.vue";
import CheckBoxValid from "./components/NewCheckBox.vue";
import NewCurrencyInput from "./components/NewCurrencyInput.vue";
import VirutalCCBar from "./components/VirutalCCBar.vue";

interface Branch {
  code: string;
  value: string;
}

// const cc_tnc_path = Constants.AEON_CC_TNC;
// const cc_psd = Constants.AEON_CC_PSD;

const cc_tnc_path = ref("");
const cc_psd_path = ref("");
const deviceType = ref("");

const { t } = i18n.global;
const error = ref(true);
const errorMessage = ref("");
const emit = defineEmits([
  "submit",
  "jumpStep",
  "previous-step",
  "getProductStep",
]);
let isTNCModalOpen = ref(false);
const pdfType = ref("");
const headerName = ref("");

const prop = defineProps({
  basicInformation: {
    type: Object as PropType<BasicInformation>,
    required: true,
  },
  personalInformation: {
    type: Object as PropType<PersonalInformation>,
    required: true,
  },
  principalDetails: {
    type: Object as PropType<PrincipalCardDetails>,
    required: true,
  },
  employmentDetails: {
    type: Object as PropType<EmploymentDetails>,
    required: true,
  },
  address: {
    type: Object as PropType<PersonalInformation>,
    required: true,
  },
  ekyc: {
    type: String,
    required: true,
  },
  nationality: {
    type: String,
    required: true,
  },
  overlay: {
    type: Boolean,
    required: true,
  },
  cardName: {
    type: String,
    required: true,
  },
  summarySetting: {
    type: Object as PropType<SummarySetting>,
    required: true,
  },
  type: {
    type: String,
  },
  countDown: {
    type: String,
  },
  status: {
    type: String,
  },
  idType: {
    type: String,
    required: true,
  },
  workplace: {
    type: String,
    required: true,
  },
  verification: {
    type: String,
  },
});

onMounted(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

const academicList = ref([]);
const deliveryList = ref([]);
const billingAddressList = ref([]);
const branchList = ref([]);
const branchListValue: Ref<Branch[]> = ref([]);

onBeforeMount(() => {
  MasterService.getTNCPath("en")
    .then((res) => {
      cc_tnc_path.value = res.data.tncDoc;
      cc_psd_path.value = res.data.pdsDoc;
    })
    .catch((e) => {});

  MasterService.getMasterData()
    .then((res) => {
      academicList.value = res.data.academicQualificationType;
      deliveryList.value = res.data.deliveryType;
      billingAddressList.value = res.data.billingAddressType;
    })
    .catch((e) => {});

  if (prop.nationality != "MY") {
    prop.personalInformation.residencyStatus = "U";
  }

  const requestModel = {
    type: "CC",
  };
  MasterService.branchCode(requestModel)
    .then((res) => {
      branchList.value = res.data.responseModel.branchList;
      branchListValue.value = res.data.responseModel.branchList;
    })
    .catch((e) => {});

  if (prop.principalDetails.deliveryOption == "") {
    if (prop.ekyc == "COMPLETE" || prop.verification == "true") {
      prop.principalDetails.deliveryOption = "H";
    } else {
      prop.principalDetails.deliveryOption = "B";
    }
  }

  if (
    prop.principalDetails.deliveryOption == "H" &&
    prop.principalDetails.address1 == ""
  ) {
    prop.principalDetails.address1 =
      prop.address.residentialAddress1.toUpperCase();
    prop.principalDetails.address2 =
      prop.address.residentialAddress2.toUpperCase();
    prop.principalDetails.address3 =
      prop.address.residentialAddress3.toUpperCase();
    prop.principalDetails.postCode = prop.address.postCode;
    postCodeData();
  }

  window.scrollTo({ top: 0, behavior: "smooth" });

  if (prop.principalDetails.eStatement == "") {
    prop.principalDetails.eStatement = "Yes";
  }
});

const question2Selection = (option: string) => {
  prop.principalDetails.eStatement = option;
  error.value = false;
};

async function postCodeData() {
  if (prop.principalDetails.postCode.length >= 5) {
    try {
      const res = await MasterService.checkPostCode(
        prop.principalDetails.postCode,
      );
      prop.principalDetails.city = res.data.responseModel.city;
      prop.principalDetails.state = res.data.responseModel.state;
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat";
    } catch (e) {
      prop.principalDetails.city = "";
      prop.principalDetails.state = "";
      schema.value.postCode =
        "minLengthNumber:5|maxLengthNumber:5|requiredNumber|invalidPostCode|numberFormat";
    }
  }
}

const getValue = computed(async () => {
  if (prop.principalDetails.postCode.length < 5) {
    prop.principalDetails.city = "";
    prop.principalDetails.state = "";
  } else if (prop.principalDetails.postCode.length >= 5) {
    await postCodeData();
  }

  return {
    city: prop.principalDetails.city,
    state: prop.principalDetails.state,
  };
});

const cityValue = ref("");
const stateValue = ref("");

async function updateValues() {
  const newValues = await getValue.value;
  cityValue.value = newValues.city;
  stateValue.value = newValues.state;
}

watch(getValue, updateValues, { immediate: true });

const openDeclarationAgreementModal = () => {
  isTNCModalOpen.value = true;

  pdfType.value = "declaration";
  headerName.value = "usagePolicy";
};

const closeTNCModal = () => {
  isTNCModalOpen.value = false;
};

const question1Selection = (option: string) => {
  prop.basicInformation.question1 = option;
  error.value = false;
};

const onSubmit = () => {
  emit("submit");
  // emit("jumpStep", 8, "", 4);
};

const schema = computed(() => {
  const billingAddress = prop.principalDetails.eStatement == "No";
  const other = prop.personalInformation.academic == "9";
  const branch = prop.principalDetails.deliveryOption == "B";
  const repayment = prop.basicInformation.question1 == "Yes";
  return {
    motherMaidenName: "required|nameFormat",
    academic: "required",
    otherAcademic: other ? "required" : "",
    name: "required|alphabetAndSpaceFormat",
    deliveryOption: "required",
    branch: branch ? "required" : "",
    deliveryAddress1: branch ? "" : "required",
    postCode: branch
      ? ""
      : "minLengthNumber:5|maxLengthNumber:5|requiredNumber|numberFormat",
    repayment: repayment ? "requiredNumber" : "",
    billingAddress: billingAddress ? "required" : "",
    sstRegistrationNo: "fixedLength:15",
  };
});

const onInvalidSubmit = () => {
  if (prop.principalDetails.eStatement == "") {
    errorMessage.value = t("ccOnBoarding.principalCard.error");
  }
};

const handleCCConsent = (value: string) => {
  if (value) prop.basicInformation.consent = value;
  else prop.basicInformation.consent = "";
};

const handleNameKeyDown = (event: KeyboardEvent) => {
  const isSymbol = /^[a-zA-Z@#()_:\/.,'\-\s]+$/.test(event.key);
  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  if (
    !isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleBack = () => {
  //TODO-Matrix
  emit("getProductStep", false, true, false, false, "");
};

// watch(
//   () => prop.principalDetails.deliveryOption,
//   (newValue) => {
//     if (newValue == "H") {
//       prop.principalDetails.address1 = prop.address.residentialAddress1;
//       prop.principalDetails.address2 = prop.address.residentialAddress2;
//       prop.principalDetails.address3 = prop.address.residentialAddress3;
//       prop.principalDetails.postCode = prop.address.postCode;
//       postCodeData();
//     }
//   }
// );

watch(
  () => prop.principalDetails.deliveryOption,
  (newValue) => {
    if (newValue == "H") {
      prop.principalDetails.branch = "";
      prop.principalDetails.branchValue = "";
    }
  },
);

watch(
  () => prop.principalDetails.branch,
  (newValue) => {
    if (newValue) {
      const branchObject = branchListValue.value.find(
        (branch) => branch.code === newValue,
      );
      if (branchObject) {
        prop.principalDetails.branchValue = branchObject.value;
      } else {
        prop.principalDetails.branchValue = "";
      }
    }
  },
);

watch(
  () => prop.principalDetails.eStatement,
  (newValue) => {
    if (newValue == "Yes") {
      prop.principalDetails.billingAddress = "";
    }
  },
);

watch(
  () => prop.principalDetails.eStatement,
  (newValue) => {
    if (newValue == "No" && prop.workplace == "No") {
      prop.principalDetails.billingAddress = "H";
    }
  },
);

const isBtnDisabled = computed(() => {
  return (
    prop.personalInformation.academic == "" ||
    (prop.personalInformation.academic == "9" &&
      prop.personalInformation.otherAcademic == "") ||
    prop.personalInformation.motherMaidenName == "" ||
    prop.principalDetails.name.length == 0 ||
    prop.principalDetails.deliveryOption.length == 0 ||
    (prop.principalDetails.deliveryOption == "B" &&
      prop.principalDetails.branch.length == 0) ||
    (prop.principalDetails.deliveryOption != "B" &&
      prop.principalDetails.address1.length == 0) ||
    (prop.principalDetails.deliveryOption != "B" &&
      prop.principalDetails.postCode.length == 0) ||
    prop.principalDetails.eStatement.length == 0 ||
    (prop.principalDetails.billingAddress == "No" &&
      prop.principalDetails.billingAddress.length == 0) ||
    prop.basicInformation.question1.length == 0 ||
    (prop.basicInformation.question1 == "Yes" &&
      prop.basicInformation.repayment == 0) ||
    prop.basicInformation.consent !== "true" ||
    (prop.employmentDetails.sstRegistrationNo != "" &&
      prop.employmentDetails.sstRegistrationNo.length != 15)
  );
});

const handleKeyDown = (event: KeyboardEvent) => {
  const isDigit = /^[0-9]$/.test(event.key);
  const isArrowKey = /^Arrow(Left|Right)$/.test(event.key);

  const isIOSArrowKey =
    event.key === "UIKeyInputLeftArrow" || event.key === "UIKeyInputRightArrow";
  const isAndroidArrowKey =
    event.key === "ArrowLeft" || event.key === "ArrowRight";

  const isDeleteKey = event.key === "Delete";
  const isBackspace = event.key === "Backspace";
  const isTabKey = event.key === " Tab";

  const isSymbol = /[^a-zA-Z0-9]/.test(event.key); // true for symbol input

  if (
    isSymbol &&
    !isBackspace &&
    !(isArrowKey || isIOSArrowKey || isAndroidArrowKey) &&
    !isDeleteKey &&
    !isTabKey
  ) {
    event.preventDefault();
  }
};

const handleEnterKey = () => {};
</script>
<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.radioClass {
  display: flex;
  align-items: flex-end;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.dropDown {
  width: 100%;
}

.container {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  padding: 0;
  margin-bottom: 14px;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.flex_half {
  width: 50%;
}

.flex_race {
  width: 50%;
}

.separator {
  margin-bottom: 37px;
}

.summary-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
  transition: background-color 0.3s ease;
}

.summary-button:hover {
  background-image:
    linear-gradient(120deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.summary-button:active {
  background-image:
    linear-gradient(120deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
  transition: background-color 0.3s ease;
}

.right-button:hover {
  background-image:
    linear-gradient(120deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.right-button:active {
  background-image:
    linear-gradient(120deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    var(
      --gradient-set-active,
      linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
    );
}

.left-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: 1px solid #cb03bc;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #cb03bc;
  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.summary-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 100%;
}

/* .inputText {
  margin-bottom: 10px;
} */

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

/* .left-button {
  flex: 0 0 15%;
} */

.agree {
  display: flex;
  align-items: flex-start;
}

/* .radioClass {
  display: flex;
} */

.radioHorizontal {
  margin-right: 24px !important;
  color: rgba(0, 0, 0, 0.38);
  margin-bottom: 5px;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;

  position: relative;
  align-self: stretch;
}

.brLine {
  margin-bottom: 8px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

@media (max-width: 700px) {
  .container:is(.Desktop, .Tablet) {
    flex-direction: column;
    gap: 14px;
  }

  .flex_dropdown:is(.Desktop, .Tablet),
  .flex_inputText:is(.Desktop, .Tablet) {
    width: 100%;
  }
  .flex_half:is(.Desktop, .Tablet) {
    width: 100%;
  }

  .flex_race:is(.Desktop, .Tablet) {
    width: 100%;
    margin-bottom: 10px;
  }

  .buttoncontainer:is(.Desktop, .Tablet) {
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .summary-button:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .summary-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 100%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 0;
  }

  /* .margin:is(.Desktop, .Tablet) {
    margin-bottom: 10px;
  } */
}

.separator .container {
  max-width: none;
}

.content:is(.Mobile) {
  padding: 0;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.inner {
  padding-top: 24px;
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.container:is(.Mobile) {
  flex-direction: column;
  gap: 14px;
}

.flex_dropdown:is(.Mobile),
.flex_inputText:is(.Mobile) {
  width: 100%;
}
.flex_half:is(.Mobile) {
  width: 100%;
}

.flex_race:is(.Mobile) {
  width: 100%;
  margin-bottom: 10px;
}

.buttoncontainer:is(.Mobile) {
  gap: 10px;
  margin-bottom: 24px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:disabled:is(.Mobile) {
  flex: 0 0 68%;
}

.summary-button:is(.Mobile) {
  flex: 0 0 100%;
}

.summary-button:disabled:is(.Mobile) {
  flex: 0 0 100%;
}

.separator:is(.Mobile) {
  margin-bottom: 0;
}

.margin:is(.Mobile) {
  margin-bottom: 0px;
}

h2 {
  color: var(--Web-Black-High, #212121);

  /* H2 */
  font-family: Outfit;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 26px */
}

.inputText {
  width: 100%;
}

.flex {
  width: 100%;
}

.description {
  color: #212121;
  font: 500 16px/130% "Outfit";
  margin-bottom: 2px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.remark {
  color: rgba(0, 0, 0, 0.38);
  font: 500 12px/130% "Outfit";
  margin-bottom: 10px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.smallTitle {
  margin-bottom: 30px;
  color: #9e9e9e;
  font: 500 14px/130% "Outfit";
  text-align: left;
  position: relative;
  align-self: stretch;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.agree2:is(.Desktop, .Tablet) {
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  border-bottom: 1px solid #e4e4e4;
}

.checkbox {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-family: Outfit;
  font-weight: 500;
  line-height: 18.2px;
  word-wrap: break-word;
}

.checkbox-label2 {
  position: relative;
  align-items: center;
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  font-family: "Outfit";
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  margin-left: 8px;
  margin-bottom: 0px;
}

.termOfService {
  background: none !important;
  border: none;
  color: #ac2887;
  font-size: 14px;
  font-family: Outfit;
  font-weight: 500;
  line-height: 18.2px;
  word-wrap: break-word;
  cursor: pointer;
  text-decoration: none;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.cardName {
  color: rgba(0, 0, 0, 0.38);
  font: 500 16px/130% "Outfit";
  margin-bottom: 10px;
  margin-top: 5px;
  text-align: left;
  position: relative;
  align-self: stretch;
}

.virtualCC:is(.Desktop, .Tablet) {
  border-bottom: 1px solid #e4e4e4;
}

.virtualCC:is(.Mobile) {
  padding: 8px 0px;
  border-bottom: none;
  border-top: 1px solid #e4e4e4;
}

.agreement {
  display: block !important;
}
</style>
